module.exports = __webpack_public_path__ + "img/download.085676f.svg";